import { render, staticRenderFns } from "./SystemMessageViewer.vue?vue&type=template&id=ffd4dcdc"
import script from "./SystemMessageViewer.vue?vue&type=script&lang=ts"
export * from "./SystemMessageViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports